import Vue from 'vue'
import * as Sentry from "@sentry/vue";
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import i18n from './locale/i18n'
import {EventBusNotification} from "./components/EventBusNotification";
import webSocketService from './services/webSocketService'
import eventLoopService from './services/eventLoopService'
/** Connection listener */
import ConnectionStateBus from "./bus/ConnectionStateBus";
import VueConnectionListener from "./plugins/vue-connection-listener";

Vue.config.productionTip = false

if(process.env.NODE_ENV === 'production'){
    Sentry.init({
        Vue,
        dsn: "https://740239220375b7a05859afabe7448235@o4511862979100672.ingest.de.sentry.io/4511863000334416",
        integrations: [
            new Sentry.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            }),
        ],
        trackComponents: true,
        logErrors: true,
        attachStacktrace: true,
        release: `${process.env.VUE_APP_APP_CUSTOM_ID}@${process.env.VUE_APP_VERSION}`,
        environment: process.env.NODE_ENV,
        tracesSampleRate: 0.2, // 20% of actions
    });
}

//Sentry.captureMessage(`Test version #2 : ${process.env.VUE_APP_VERSION}`);
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })
Vue.use(VueAxios, axios)

Vue.use(webSocketService, {
    server_api: `${process.env.VUE_APP_WEBSOCKET_ENDPOINT}`,
    store:store,

    //Outsourced in eventLayout
    /*
    onConnected:(eventId,isReconnect)=>{},
    onCheckin:(spot_id) => {},
    onSolve:(eventId) => {},
    onTeamPhotoChange:(person_id)=>{},
    onTeamNameChange:(person_id)=>{},
    onLeaderChange:(person_id,agree)=>{},
    onLeaderChangeRequest:(person_id,time_utc)=>{}
    */
})

Vue.use(eventLoopService, {
    server_api: `${window.location.protocol}//${window.location.host}/`,
    refreshEvent:(data)=>{
        store.dispatch('events/refresh',data);
    },
    refreshSpotList:(data)=>{
        store.dispatch('spots/refreshSpots', data);
    }
});

const connectionListener = new VueConnectionListener(ConnectionStateBus); // Create instance (injecting our bus)
Vue.prototype.$connection = ConnectionStateBus; // Optional (but convenient)

new Vue({
    mixins: [EventBusNotification],
    i18n,
    router,
    store,
    vuetify,
    render: h => h(App),
    created() {
        connectionListener.register();
    },
    destroyed() {
        connectionListener.unregister();
    }
}).$mount('#app')
